<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm @submit.prevent="submit" validated novalidate>
                <ValidationObserver ref="observer">
                  <h1>회원가입</h1>
                  <p class="text-muted">계정을 생성합니다</p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="username"
                    rules="required|min:1|max:100"
                  >
                    <CInput
                      placeholder="아이디"
                      autocomplete="username"
                      v-model="form.username"
                      :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                      :is-valid="errors.length > 0 ? false : null"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-user" />
                      </template>
                    </CInput>
                  </ValidationProvider>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="password"
                    rules="required|min:9|max:20"
                  >
                    <CInput
                      placeholder="비밀번호"
                      type="password"
                      autocomplete="new-password"
                      v-model="form.password"
                      :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                      :is-valid="errors.length > 0 ? false : null"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-lock-locked" />
                      </template>
                    </CInput>
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="confirmPassword"
                    rules="required|password:@password|min:9|max:20"
                  >
                    <CInput
                      placeholder="비밀번호 확인"
                      type="password"
                      autocomplete="new-password"
                      v-model="form.confirmPassword"
                      :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                      :is-valid="errors.length > 0 ? false : null"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-lock-locked" />
                      </template>
                    </CInput>
                  </ValidationProvider>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="email"
                    rules="required|email|min:4|max:100"
                  >
                    <CInput
                      placeholder="이메일"
                      autocomplete="email"
                      prepend="@"
                      v-model="form.email"
                      :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                      :is-valid="errors.length > 0 ? false : null"
                    />
                  </ValidationProvider>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="name"
                    rules="required|min:1|max:100"
                  >
                    <CInput
                      placeholder="이름"
                      autocomplete="name"
                      v-model="form.name"
                      :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                      :is-valid="errors.length > 0 ? false : null"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-user" />
                      </template>
                    </CInput>
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="phone"
                    rules="required|phone|min:12|max:13"
                  >
                    <CInput
                      placeholder="휴대전화"
                      type="tel"
                      autocomplete="phone"
                      v-model="form.phone"
                      :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                      :is-valid="errors.length > 0 ? false : null"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-mobile" />
                      </template>
                    </CInput>
                  </ValidationProvider>

                  <CButton type="submit" color="success" block
                    >회원가입
                  </CButton>
                </ValidationObserver>
              </CForm>
            </CCardBody>
            <!--            <CCardFooter class="p-4">-->
            <!--              <CRow>-->
            <!--                <CCol col="6">-->
            <!--                  <CButton block color="facebook">-->
            <!--                    Facebook-->
            <!--                  </CButton>-->
            <!--                </CCol>-->
            <!--                <CCol col="6">-->
            <!--                  <CButton block color="twitter">-->
            <!--                    Twitter-->
            <!--                  </CButton>-->
            <!--                </CCol>-->
            <!--              </CRow>-->
            <!--            </CCardFooter>-->
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import { email, max, min, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import UserService from "@/services/user/user.service";
import core from "@/core";
import axios from "axios";

extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    //console.log('value : ', value, ', target : ', target);
    return value === target;
  },
  message: "비밀번호 확인이 일치하지 않습니다",
});
extend("phone", {
  validate(value) {
    return core.utils.validate.phone(value);
  },
  message: "휴대전화 형식이 올바르지 않습니다",
});

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    username: "아이디",
    password: "비밀번호",
    confirmPassword: "비밀번호 확인",
    email: "이메일",
    name: "이름",
    phone: "휴대전화",
  },
});
export default {
  name: "Register",

  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        confirmPassword: "",
        email: "",
        name: "",
        phone: "",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      core.loader.hide();
    });
  },
  watch: {
    "form.phone"() {
      this.form.phone = core.utils.format.hyphenPhone(this.form.phone);
    },
  },
  methods: {
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        const params = core.utils.deepCopy(this.form);
        try {
          const result = await UserService.register(params);
          core.loader.hide();
          const alertResult = await core.alert.show({
            title: "알림",
            icon: "info",
            body: "회원가입이 완료되었습니다.",
            confirmButtonText: "확인",
          });
          axios.post("/fs/register",params).then(val=>{
            console.log(val)
          });
          this.$router.push("/login");
        } catch (e) {
          core.loader.hide();
          console.log("error : ", e);
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
